/* eslint-disable no-undef */

const KEYS = {
  TOKEN: 'token',
  PHONE_NUMBER: 'phone',
  REQUEST_ID: 'requestId'
};

class PersistenceService {

  public static getToken(): string {
    return PersistenceService.retrieve(KEYS.TOKEN);
  }

  public static storeToken(token: string): void {
    PersistenceService.store(KEYS.TOKEN, token);
  }

  public static getPhoneNumber(): string {
    return PersistenceService.retrieve(KEYS.PHONE_NUMBER);
  }

  public static storePhoneNumber(phoneNumber: string): void {
    PersistenceService.store(KEYS.PHONE_NUMBER, phoneNumber);
  }

  public static getRequestId(): string {
    return PersistenceService.retrieve(KEYS.REQUEST_ID);
  }

  public static storeRequestId(requestId: string): void {
    PersistenceService.store(KEYS.REQUEST_ID, requestId);
  }

  public static reset(): void {
      localStorage.clear();
  }

  private static store(key: string, value: any): void {
    localStorage.setItem(key, value);
  }

  private static retrieve(key: string): any {
    return localStorage.getItem(key);
  }

}

export default PersistenceService;
